<header>
  <div class="header-container">
    <div class="site-title" (click)="goToHome()" style="cursor: pointer;" *ngIf="showHeader">
      <img src="hechos.webp" alt="Logo" class="logo-icon" />
      <div class="title-text">
        <span class="title-bold">FÁCIL</span><br />
        <span class="title-light">CONTRATO</span>
      </div>
    </div>

    <div class="menu-container" *ngIf="showHeader">
      <button class="menu-icon" (click)="toggleMenu()" [class.open]="menuOpen">
        <span></span>
        <span></span>
        <span></span>
      </button>

      <div class="side-menu" [class.open]="menuOpen">
        <button (click)="goToHome()">🏠 Inicio</button>
        <button (click)="goToProfile()">👤 Perfil</button>
        <button (click)="onLogout()">🚪 Cerrar Sesión</button>
      </div>
    </div>
  </div>
</header>
